import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { selector } from "../../../api";
import { accountingCRUD } from "../../../actions/accounting";
import { TableShared } from "../../../shared";
import { char } from "../../../utils";
import {
  Badge,
  Button,
  ConfigProvider,
  Dropdown,
  Space,
  notification,
} from "antd";
import {
  PlusCircleOutlined,
  MoreOutlined,
  DeleteOutlined,
  EyeOutlined,
  EditOutlined,
} from "@ant-design/icons";
import CloseIcon from "@rsuite/icons/Close";
import { Input, InputGroup, SelectPicker } from "rsuite";
import { StudentDetails } from "./details";

export const StudentContent = () => {
  const [open, setOpen] = useState(false);
  const [openData, setOpenData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [searchType, setSearchType] = useState(null);
  const [name, setName] = useState("");
  const [regNumber, setRegNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [searchIndex, setSearchIndex] = useState(0);
  const [dataId, setDataId] = useState(null);
  const [registration, setRegistration] = useState(null);

  const [api, contextHolder] = notification.useNotification();

  const user = selector.User();

  useEffect(() => {
    if (searchType) {
      setLoading(true);
      setTimeout(() => {
        accountingCRUD
          .loadStudentByFilter(
            postsPerPage,
            nextPage,
            name,
            phone,
            regNumber,
            "",
            "-id",
          )
          .then((resp) => {
            setData(resp.data.results);
            setCount(resp.data.count);
          })
          .catch((error) => {
            api.error({
              message: error.message,
              description:
                "Oops! It looks like you're not connected to the network. Please check your network connectivity and try again",
              placement: "topRight",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    } else {
      setLoading(true);
      setTimeout(() => {
        accountingCRUD
          .loadStudent(postsPerPage, nextPage, value, "-id")
          .then((resp) => {
            setData(resp.data.results);
            setCount(resp.data.count);
          })
          .catch((error) => {
            api.error({
              message: error.message,
              description:
                "Oops! It looks like you're not connected to the network. Please check your network connectivity and try again",
              placement: "topRight",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [page, postsPerPage, value, index, nextPage, searchIndex]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 50,
    },
    {
      key: "registration_number",
      title: "Reg Number",
      dataIndex: "registration_number",
      sortable: true,
      width: 130,
    },
    {
      key: "name",
      title: "Full Name",
      dataIndex: "name",
      sortable: true,
      width: 250,
    },
    {
      key: "address",
      title: "Address",
      dataIndex: "address",
      sortable: true,
      width: 130,
    },
    {
      key: "phone_number",
      title: "Phone Number",
      dataIndex: "phone_number",
      sortable: true,
      width: 90,
    },
    {
      key: "email",
      title: "Email Address",
      dataIndex: "email",
      sortable: true,
      width: 150,
    },
    {
      key: "programme",
      title: "Programme",
      dataIndex: "programme",
      sortable: true,
      width: 210,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 60,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 50,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "View",
                key: "view",
                icon: <EyeOutlined />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "view":
                  setOpenData(true);
                  setDataId(record.id);
                  setRegistration(record.registration_number);
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    registration_number: dt.registration_number
      ? char.toUpperCase(dt.registration_number)
      : "N/A",
    name: dt.name ? char.toTitleCase(dt.name) : "N/A",
    address: dt.address ? char.toTitleCase(dt.address) : "N/A",
    phone_number: dt.phone_number ? dt.phone_number : "N/A",
    email: dt.email ? dt.email : "N/A",
    programme: dt.programme ? char.toTitleCase(dt.programme.name) : "N/A",
    status: dt.is_active ? (
      <span class="badge badge-soft-success badge-border">
        {char.toTitleCase("active")}
      </span>
    ) : (
      <span class="badge badge-soft-danger badge-border">
        {char.toTitleCase("inactive")}
      </span>
    ),
  }));

  const search = (
    <>
      <div className="col-md-3 col-sm-12">
        <SelectPicker
          size="lg"
          style={{
            width: "100%",
          }}
          placeholder="Search by ...."
          optionFilterProp="children"
          onChange={(e) => {
            setSearchType(e);
            setName("");
            setRegNumber("");
            setPhone("");
          }}
          cleanable
          onClean={() => {
            setSearchType(null);
            setName("");
            setRegNumber("");
            setPhone("");
            setSearchIndex(searchIndex + 1);
          }}
          data={[
            {
              label: "Student Name",
              value: "name",
            },
            {
              label: "Registration Number",
              value: "regNumber",
            },
            {
              label: "Phone Number",
              value: "phone",
            },
          ]}
        />
      </div>
      {searchType === "name" && (
        <div className="col-md-3 col-sm-12">
          <InputGroup inside style={{ width: 300 }}>
            <Input
              placeholder="Search by student name"
              size="lg"
              value={name}
              onChange={(e) => setName(char.toLowerCase(e))}
            />
            {name && (
              <InputGroup.Button
                size="lg"
                onClick={() => {
                  setName("");
                  setSearchIndex(searchIndex + 1);
                }}
              >
                <CloseIcon />
              </InputGroup.Button>
            )}
          </InputGroup>
        </div>
      )}
      {searchType === "regNumber" && (
        <div className="col-md-3 col-sm-12">
          <InputGroup inside style={{ width: 300 }}>
            <Input
              placeholder="Search by registration number"
              size="lg"
              value={regNumber}
              onChange={(e) => setRegNumber(char.toLowerCase(e))}
            />
            {regNumber && (
              <InputGroup.Button
                size="lg"
                onClick={() => {
                  setRegNumber("");
                  setSearchIndex(searchIndex + 1);
                }}
              >
                <CloseIcon />
              </InputGroup.Button>
            )}
          </InputGroup>
        </div>
      )}
      {searchType === "phone" && (
        <div className="col-md-3 col-sm-12">
          <InputGroup inside style={{ width: 300 }}>
            <Input
              placeholder="Search by phone number"
              size="lg"
              value={phone}
              onChange={(e) => setPhone(char.toLowerCase(e))}
            />
            {phone && (
              <InputGroup.Button
                size="lg"
                onClick={() => {
                  setPhone("");
                  setSearchIndex(searchIndex + 1);
                }}
              >
                <CloseIcon />
              </InputGroup.Button>
            )}
          </InputGroup>
        </div>
      )}
      {searchType && (
        <div className="col-md-2 col-sm-12">
          <button
            className="btn btn-soft-info"
            onClick={() => {
              setSearchIndex(searchIndex + 1);
            }}
          >
            <span className="bi bi-search"></span> &nbsp; Search
          </button>
        </div>
      )}
      <div
        className={
          searchType
            ? "col-md-4 col-sm-12 d-flex flex-row-reverse"
            : "col-md-9 col-sm-12 d-flex flex-row-reverse"
        }
      >
        {null}
      </div>
    </>
  );

  return (
    <>
      {contextHolder}
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">Student</p>
          </div>
          <hr className="mt-3" />
        </div>
        <TableShared
          setOpen={setOpen}
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={null}
          link={"#"}
          showButton={true}
          search={search}
          showSearch={true}
          setLoading={setLoading}
        />
      </div>
      <StudentDetails
        open={openData}
        setOpen={setOpenData}
        index={index}
        setIndex={setIndex}
        dataId={dataId}
        registration={registration}
      />
    </>
  );
};
